import { useEffect, useState } from "react";

export const useCheckNetwork = () => {
  const [isOnline, setOnline] = useState<boolean>(true);

  useEffect(() => {
    window.addEventListener("offline", () => {
      setOnline(false);
    });
    window.addEventListener("online", () => {
      setOnline(true);
    });

    return () => {
      window.removeEventListener("offline", () => {
        setOnline(false);
      });
      window.removeEventListener("online", () => {
        setOnline(true);
      });
    };
  }, []);
  return isOnline;
};
